var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcPromotion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4697 1.46967C11.6103 1.32902 11.8011 1.25 12 1.25L22.75 1.25L22.75 12C22.75 12.1989 22.671 12.3897 22.5303 12.5304L12.5304 22.5303C12.2375 22.8232 11.7626 22.8232 11.4697 22.5303L1.46967 12.5303C1.32902 12.3896 1.25 12.1989 1.25 12C1.25 11.8011 1.32902 11.6103 1.46967 11.4696L11.4697 1.46967ZM12.3106 2.75L3.06066 12L12 20.9393L21.25 11.6894L21.25 2.75L12.3106 2.75ZM15.2494 6.50001C15.2494 5.25737 16.2568 4.25001 17.4994 4.25001C18.742 4.25001 19.7494 5.25737 19.7494 6.50001C19.7494 7.74265 18.742 8.75001 17.4994 8.75001C16.2568 8.75001 15.2494 7.74265 15.2494 6.50001ZM17.4994 5.75001C17.0852 5.75001 16.7494 6.0858 16.7494 6.50001C16.7494 6.91423 17.0852 7.25001 17.4994 7.25001C17.9136 7.25001 18.2494 6.91423 18.2494 6.50001C18.2494 6.0858 17.9136 5.75001 17.4994 5.75001Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPromotion);
export default __webpack_public_path__ + "static/media/ic_promotion.fb5f709eeb84e92f999a0f244eee2ed6.svg";
export { ForwardRef as ReactComponent };